// The fleet page as it was written by hand, before it could be edited from the admin page.
//
// This is the starting point, not the source of truth: once anything has been saved from
// /fleet-admin the server's copy is what both the page and the editor use. It stays here so
// the page still renders if the API cannot be reached, and so the editor has something to open
// the first time it is used.
//
// Images are stored as paths rather than bare file names, because an uploaded one is served
// from the API rather than from /images/livery.
const livery = (name) => `/images/livery/${name}`;

export const FLEET_DEFAULT = {
  intro: {
    title: "About Our Liveries",
    paragraphs: [
      "Every livery in our hangar is based on a real-world airframe. We focus on correct decals, mismatching panels, and details that match how the aircraft actually looked in service. No shortcuts - just consistent, research-driven work that fits naturally into normal line operations and long-term fleet realism.",
      "Our fleet is created by experienced, professional painters, including Benek, a well-known and respected livery author, alongside a small team of contributors with extensive simulator and real-world reference experience.",
    ],
    painters: [
      { group: "Fenix (MSFS)", names: "Benek" },
      { group: "FSLabs (MSFS)", names: "Benek, Dejw, Rob" },
      { group: "ToLiss (XP)", names: "Mati, Harry, Gabor" },
    ],
  },
  sections: [
    {
      title: "FENIX SIMULATIONS A320 / A321",
      platform: "MSFS 2020 / 2024",
      cards: [
        {
          title: "Fleet Variety",
          text: "Complete fleet diversity featuring the A320ceo with both wing-tip-fence and sharklet, alongside the A321ceo. All of our liveries have accurate panel mismatch and custom roughness maps for almost every registration.",
          images: ["fnxflt5.png", "fnxflt4.png", "fnxflt8.png", "fnxflt6.png", "fnxflt1.png", "fnxflt2.png", "fnxflt7.png", "fnxflt3.png"].map(livery),
        },
        {
          title: "Detailed Textures",
          text: "Ultra-high definition 8K textures that capture every rivet, dirt streak, and fluid leak. We utilize custom roughness maps to replicate the exact look of a hardworking low-cost airliner.",
          images: ["fnxtxt2.png", "fnxtxt3.png", "fnxtxt4.png", "fnxtxt6.png", "fnxtxt5.png", "fnxtxt7.png"].map(livery),
        },
        {
          title: "Custom Cabin",
          text: "Step inside a fully customized Wizz Air interior. Custom safety cards and galley carts - the experience continues behind the cockpit door.",
          images: ["fnxcab1.png", "fnxcab2.png", "fnxcab3.png", "fnxcab4.png", "fnxcab5.png", "fnxcab6.png"].map(livery),
        },
      ],
    },
    {
      title: "FLIGHT SIM LABS A321neo",
      platform: "MSFS 2020 / 2024",
      cards: [
        {
          title: "A321neo Exclusive",
          text: "High-fidelity A321neo recreation specifically for MSFS with custom decals and updated roughness maps.",
          images: ["fslfront.png", "fslwmr.png", "fsllgi.png", "fsllrd.png", "fslwnm.png", "fslwmr1.png"].map(livery),
        },
        {
          title: "Attention to Detail",
          text: "Custom engine textures to mirror GTF engines until they are released by FSLabs, plus up-to-date mismatching panels.",
          images: ["fslmid1.png", "fslmid2.png", "fslmid3.png", "fslmid4.png", "fslmid5.png"].map(livery),
        },
        {
          title: "Visual Fidelity",
          text: "Precise color matching and accurate decal positioning for all standard and special liveries in the fleet.",
          images: ["fsldet1.png", "fsluna.png", "fsldet2.png", "fsldet3.png", "fsldet4.png", "fsldet5.png"].map(livery),
        },
      ],
    },
    {
      title: "TOLISS A320 / A321",
      platform: "X-PLANE 11 / 12",
      cards: [
        {
          title: "Full Fleet",
          text: "Extensive fleets for both ToLiss NEO and CEO aircraft, CARDA mod compatibility, and frequent livery updates to match their respective real-world state.",
          images: ["tlwnd.png", "tlwdr.png", "tlwmr1.png", "tlwmr2.png", "tlwmr3.png", "tlwdx.png", "tllzu1.png", "tllzu.png", "tllxi.png"].map(livery),
        },
        {
          title: "Detailed Textures",
          text: "High-quality 4K resolution textures with good optimization, detail, and X-Plane 12/11 compatibility.",
          images: ["tlmid1.png", "tlmid2.png", "tlmid3.png", "tlmid4.png", "tlmid5.png"].map(livery),
        },
        {
          title: "Custom Cabin",
          text: "A custom-painted cabin with high quality, accuracy, and detail on all A320 family aircraft.",
          images: ["tlcab1.png", "tlcab2.png", "tlcab3.png"].map(livery),
        },
      ],
    },
  ],
};
